/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import router from "@/router";
import store from "@/store";
import axios from "axios";
import { ElMessageBox, ElNotification } from "element-plus";

// 阻止多个弹窗
let isReloginShow = false;

// 创建axios实例
const request = axios.create({
  // 127.0.0.1、http://192.168.1.100:200/admin/v1
  baseURL: "https://api.666gems.com/v1", //所有的请求地址前缀部分,https://www.fastmock.site/mock/2e48cbfb32a494b04c5a030b1094530a/test
  timeout: 10000, //请求超时时间（毫秒10*1000=10s）
  // withCredentials: true,
  // withCredentials: false, //异步请求携带cookie
  responseType: "json",
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded", //application/json;charset=utf-8
  // },
});

// request请求拦截
request.interceptors.request.use(
  (config) => {
    // if (config) {
    //   //将数据转成json格式
    //   if (config.method === "POST" || config.method === "PUT") {
    //     //这里有个坑，一定要多加一层params
    //     config.data = JSON.stringify(config.data.params);
    //   }
    // }
    // 设置请求头
    config.headers["Authorization"] = store.getters.getToken;

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    Promise.reject(error);
  }
);

// request响应拦截器
request.interceptors.response.use(
  (res) => {
    // if (!res?.data) {
    //   return res;
    // }

    const { code, data, message } = res.data;

    if (!code) {
      return res.data;
    }

    switch (code) {
      case 401:
        if (!isReloginShow) {
          isReloginShow = true;
          // 弹出框
          ElMessageBox.confirm("登录状态已过期，请重新登录", "系统提示", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showCancelButton: false,
            showClose: false,
          }).then(() => {
            // 删除缓存
            store.dispatch("logout");
            // 跳转登录页面
            router.replace("/account/login");
          });
          // 设置定时器，确保下次异常时弹出框正常弹出
          setTimeout(() => {
            isReloginShow = false;
          }, 3000);
        }
        break;
      case 10403:
        if (!isReloginShow) {
          isReloginShow = true;
          // 弹出框
          ElMessageBox.confirm(message, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showCancelButton: false,
            showClose: false,
          }).then(() => {
            // 删除缓存
            store.dispatch("logout");
            // 跳转登录页面
            router.replace("/account/login");
          });
          // 设置定时器，确保下次异常时弹出框正常弹出
          setTimeout(() => {
            isReloginShow = false;
          }, 3000);
        }
        break;
      case 10000:
        //没有ElNotification提示

        return res.data; //如果直接返回data,前端取不到code
      default:
        // return Promise.reject({ code, message });
        ElNotification({
          title: "Error " + code,
          message: message,
          type: "error",
        });

        return;
    }
  },
  async (error) => {
    let { message, response } = error;

    if (message == "Network Error") {
      // 删除缓存Too many requests, try again after 59 seconds.
      store.dispatch("logout");
      // 跳转登录页面
      router.replace("/account/login");
      message = "服务器异常，请稍后重试";
    } else if (message.includes("timeout")) {
      message = "网络请求超时，请稍后再试";
    } else if (message.includes("429")) {
      message = "操作过于频繁，请稍后再试";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    } else {
      ElNotification({
        title: "Error ",
        message: "接口路径不存在",
        type: "error",
      });
    }

    if (error.response) {
      const { status, config: c } = error.response;

      switch (status) {
        case 403:
          router.push("/403");
          break;
        case 404:
          router.push("/404");
          break;
        case 500:
          router.push("/500");
          break;
        case 502:
          router.push("/502");
          break;
      }
    }
    // return Promise.reject({ message: error.message });

    ElNotification({
      title: "Error",
      message: message,
      type: "error",
    });

    return;
  }
);

export default request;
